<template>
  <Modal title="Change node label and color" :value="true" @input="$emit('close')">
    <v-text-field label="Node label" v-model="localValue.title" outline />
    <ColorPanel v-model="localValue.itemStyle.color" />
    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: !isChanged }" @click="$emit('input', localValue)">OK</v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../common/modal/HvhModal.vue';
import { ColorPanel } from 'one-colorpicker';
import cloneDeep from 'clone-deep';

export default {
  components: { Modal, ColorPanel },
  props: ['value'],
  data() {
    return {
      localValue: cloneDeep(this.value),
    };
  },
  computed: {
    isChanged() {
      return this.value.title !== this.localValue.title || this.value.itemStyle.color !== this.localValue.itemStyle.color;
    },
  },
};
</script>